"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regex = require("@slyk/regex");

/**
 * Module dependencies.
 */

/**
 * Export `payspaceRoutes`.
 */
var _default = {
  acceptInvitation: '/accept-invitation',
  confirmEmail: '/confirm-email',
  home: '/',
  payspaceNotActive: '/payspace-not-active',
  products: {
    base: '/products',
    details: "/products/:id(".concat(_regex.uuid, ")")
  },
  resetPassword: '/reset-password',
  resetPasswordSuccess: '/reset-password-success',
  tasks: {
    details: "/tasks/:id(".concat(_regex.uuid, ")")
  }
};
exports["default"] = _default;